import SignUpInput from "components/SignUpInput";
import { Figures } from "pages/Main/HeroSection/Figures";
import { MainCopy, SubCopy } from "pages/styled";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import ProjectImageSrc from "../project.png";
import {
  FluidWrapper,
  HeroImage,
  HeroImageWrapper,
  HeroText,
  Wrapper,
} from "./styled";

export function HeroSection() {
  const { t } = useTranslation();
  return (
    <FluidWrapper>
      <Wrapper data-component="hero-section">
        <HeroText>
          <MainCopy>
            <Trans i18nKey="main.heroSection.mainCopy" />
          </MainCopy>
          <SubCopy>{t("main.heroSection.subCopy")}</SubCopy>
          <SignUpInput formId="main-hero-sign-up-form" />
        </HeroText>
        <HeroImageWrapper>
          <HeroImage src={ProjectImageSrc} />
        </HeroImageWrapper>
      </Wrapper>
      <Figures />
    </FluidWrapper>
  );
}
